// extracted by mini-css-extract-plugin
export default {"checkbox":"_35rt-___FilterDropdown-module__checkbox","labelText":"kKcWj___FilterDropdown-module__labelText","innerCheckbox":"_3XTak___FilterDropdown-module__innerCheckbox"};